export default __webpack_public_path__ + "static/media/logo.b4fb7ed5.png";